const TitleFilterAttribute = {
	Supplier: {
		attribute: 'supplier',
		label: 'Imprint / Publisher',
	},
	Format: {
		attribute: 'format',
		label: 'Format',
	},
	Category: {
		attribute: 'category',
		label: 'Category',
	},
	Series: {
		attribute: 'series',
		label: 'Series',
	},
	PubDateRange: {
		attribute: 'pubDatePeriodDisplay',
		label: 'Published Date Range',
	},
	PublishingStatus: {
		attribute: 'publishingStatus',
		label: 'Publishing Status',
	},
	ReviewCopyAvailability: {
		attribute: 'reviewCopyAvailability',
		label: 'Review Copy Availability',
	},
	MarkupNoteIndicator: {
		attribute: 'markupNoteIndicator',
		label: 'Markup Notes',
	},
};

export default TitleFilterAttribute;
